<template>
  <div class="user-profile">
    <h1>个人中心</h1>
    <p>这里是个人中心页面。</p>
  </div>
</template>

<script>
export default {
  name: 'UserProfile',
};
</script>

<style scoped>
.user-profile {
  padding: 20px;
}

h1 {
  margin: 0 0 10px;
}
</style>